import { useEffect, useRef } from 'react';
import { useGlobalWalletSignerAccount } from '@abstract-foundation/agw-react';
import { useAccount } from 'wagmi';
import { useAppContext } from '../contexts/hooks';
import { setSentryUser } from '../sentry';

const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true';
const ABSTRACT_CONNECTOR_ID = 'xyz.abs.privy';

export function useWagmiSync() {
  const { address, connector, isConnected } = useAccount();
  const { address: abstractSignerAddress } = useGlobalWalletSignerAccount();
  const { dispatch } = useAppContext();
  const prevAddress = useRef<string | undefined>(undefined);
  const isAbstractWallet = connector?.id === ABSTRACT_CONNECTOR_ID || connector?.name === 'Abstract';
  const activeAddress = isAbstractWallet ? abstractSignerAddress : address;

  useEffect(() => {
    if (USE_MOCK) return;

    if (isConnected && activeAddress && activeAddress !== prevAddress.current) {
      prevAddress.current = activeAddress;
      dispatch({ type: 'SYNC_CONNECTED_WALLET', chain: 'evm', address: activeAddress });
      setSentryUser(activeAddress, 'evm');
    }

    if (!isConnected && prevAddress.current) {
      prevAddress.current = undefined;
      dispatch({ type: 'DISCONNECT_CHAIN', chain: 'evm' });
      setSentryUser(null, null);
    }
  }, [isConnected, activeAddress, dispatch]);
}
